import { createAxios } from './createAxios'
import service from './contactApi'
import { Message } from 'element-ui'

import store from '@/store'

// service 循环遍历输出不同的请求方法
const instance = createAxios()

const Http = {} // 包裹请求方法的容器

for (const key in service) {
  const api = service[key]

  Http[key] = async function(
    params, // 请求参数 get: url, put, post, patch(data), delete: url
    isFormData = false, // 是否是form-data请求
    config = {}
  ) {
    // if (['/machiningTrace', '/farSell/find'].indexOf(api.url) > -1) {
    //   api.url = api.url + '/' + config.variable
    // }
    // // const url = api.url
    let newParams = {}

    if (params && isFormData) {
      newParams = new FormData()
      for (const i in params) {
        newParams.append(i, params[i])
      }
    } else {
      // newParams = params
      for (const i in params) {
        newParams[i] = params[i]
      }
    }

    // 不同请求的判断
    let response = {}
    if (api.method === 'put' || api.method === 'post' || api.method === 'patch') {
      try {
        response = await instance[api.method](api.url, newParams, config)
      } catch (err) {
        response = err
      }
    } else if (api.method === 'delete' || api.method === 'get') {
      config.params = newParams
      try {
        response = await instance[api.method](api.url, config)
      } catch (err) {
        response = err
      }
    }
    return new Promise((resolve, reject) => {
      resolve(response)
      // if (response.code === 20000) {
      //   resolve(response)
      // } else {
      //   reject(response)
      // }
    })
  }
}

// 拦截器
instance.interceptors.request.use(config => {
  config.headers['Content-Type'] = 'application/json'
  if (store.getters.getToken) {
    config.headers['Authorization'] = store.getters.getToken // 让每个请求携带自定义token
  }
  return config
}, () => {
  Message('请求错误，请稍后重试')
})

instance.interceptors.response.use(res => {
  // const resp = res.data
  // if (resp.code !== 20000) {
  //   if (['登录过期', 'token查询有误', '无效token', '缺少Authorization头信息'].indexOf(resp.msg) > -1) {
  //     // token超时
  //     store.commit('changeToken', '')
  //     Message('登录超时，请重新登录')
  //     location.hash = '#/login'
  //   } else {
  //     Message(resp.msg)
  //   }
  //   return resp
  // } else {
  //   return resp
  // }
  return res.data
}, (err) => {
  console.error(err)
})

export const http = Http
export const Instance = instance
